import { Component } from '@angular/core';

@Component({
  selector: 'app-api-requests',
  templateUrl: './api-requests.component.html',
  styleUrl: './api-requests.component.scss'
})
export class ApiRequestsComponent {

}
